import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "../../../shared/services/translate.service";
import {SchoolProgramService} from "../../../shared/services/school-program.service";
import {AcademicYear} from "../../../shared/models/academic-year.model";
import Swal from "sweetalert2";
import {AcademicCalendarService} from "../../../shared/services/academic-calendar.service";
import { ResponseService } from 'src/shared/services/response-service.service';
import { AuthService } from 'src/shared/services/auth.service';
import { SchoolProgramGridComponent } from "./school-program-grid/school-program-grid.component";

@Component({
  selector: 'app-school-program',
  templateUrl: './school-program.component.html',
  styleUrls: ['./school-program.component.scss']
})
export class SchoolProgramComponent implements OnInit {
  @ViewChild('addSchoolProgram', {static: true}) public modalAddSchoolProgram: NgbModalRef;
  @ViewChild('addCategory', {static: true}) public modalAddCategory: NgbModalRef;
  constructor(
      private modalService: NgbModal,
      private cd: ChangeDetectorRef,
      private translate: TranslateService,
      private schoolProgramService: SchoolProgramService,
      private academicService: AcademicCalendarService,
      private rpSer: ResponseService,
      public auth: AuthService
  ) {
  }
  paramForm: FormGroup;
  hasData: boolean = false;
  task = null;
  searchText: string = '';
  loading = false;
  addProgramForm :FormGroup;
  addCategoryForm :FormGroup;
  disableCategorySubmit = true;
  disableProgramSubmit = true;
  changes = false;
  currentAcademic : AcademicYear | null = null;

  onOpenSchoolProgramGrid() {
    const modalRef = this.modalService.open(SchoolProgramGridComponent, {
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
      centered: true,
    });
    modalRef.result.then(
      () => {
        this.changes = !this.changes;
      },
      () => {
      },
    );
  }

  ngOnInit() {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular', 'activity');
    this.initForm();
    this.trackFormChanges();
    this.getCurrentAcademicYear();
  }
  trackFormChanges() {
    this.addCategoryForm.valueChanges.subscribe(() => {
      this.disableCategorySubmit =
          !this.addCategoryForm.get('school_program_id')?.value ||
          !this.addCategoryForm.get('category_name')?.value ||
          !this.addCategoryForm.get('category_description')?.value ||
          !this.addCategoryForm.get('school_location_id')?.value;
    });

    this.addProgramForm.valueChanges.subscribe(() => {
      this.disableProgramSubmit =
          !this.addProgramForm.get('school_location_id')?.value ||
          !this.addProgramForm.get('school_program_name')?.value ||
          !this.addProgramForm.get('school_program_description')?.value;
    });

  }
  filter(event: any) {
    this.searchText = event;
    this.changes = !this.changes;
  }
  initForm() {
    this.paramForm = new FormGroup({
      'name': new FormControl(null),
      'academic_year': new FormControl(null),
      'period_id': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'school_level_relation_id': new FormControl(null)
    });
    this.resetAdd();
    this.resetCategory();
  }

  resetAdd() {
    this.addProgramForm = new FormGroup({
      'school_location_id': new FormControl(null),
      'academic_year': new FormControl(null),
      'school_program_name': new FormControl(null),
      'school_program_description': new FormControl(null),
    })
    this.disableProgramSubmit = true;
  }
  resetCategory() {
    this.addCategoryForm = new FormGroup({
      'school_location_id': new FormControl(null),
      'academic_year': new FormControl(null),
      'school_program_id': new FormControl(null),
      'category_name': new FormControl(null),
      'category_description': new FormControl(null),
    })
    this.disableCategorySubmit = true;
  }

  onChangeAcademicYear(item: any, mode ='list') {
    if (mode == 'list'){
      this.paramForm.controls['academic_year'].markAsTouched();
      this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

      this.paramForm.controls['school_location_id'].setValue(null);
    } else if (mode == 'addProgram') {
      this.addProgramForm.controls['academic_year'].markAsTouched();
      this.addProgramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

      this.addProgramForm.controls['school_location_id'].setValue(null);
    } else {
      this.addCategoryForm.controls['academic_year'].markAsTouched();
      this.addCategoryForm.controls['academic_year'].setValue(item ? item.academic_year : null);
      this.addCategoryForm.controls['school_location_id'].setValue(null);
    }

  }

  onChangeSchoolProgram(item: any) {
    this.addCategoryForm.controls['school_program_id'].markAsTouched();
    this.addCategoryForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);
  }
  onChangeSchoolLocation(item: any, mode = 'list') {
    if (mode == 'list'){
      this.paramForm.controls['school_location_id'].markAsTouched();
      this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);
    } else if (mode == 'addProgram') {
      this.addProgramForm.controls['school_location_id'].markAsTouched();
      this.addProgramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);
    } else {
      this.addCategoryForm.controls['school_location_id'].markAsTouched();
      this.addCategoryForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

      this.addCategoryForm.controls['school_program_id'].setValue(null);
    }
    this.cd.detectChanges();
  }

  onOpenModelAddSchoolProgram () {
    this.translate.load('extracurricular', 'activity');
    this.modalService.open(this.modalAddSchoolProgram, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  onOpenModelAddCategory () {
    this.translate.load('extracurricular', 'activity');
    this.modalService.open(this.modalAddCategory, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  onAddSchoolProgram() {
    const data = this.addProgramForm.value;
    this.schoolProgramService.createSchoolProgram(data).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showAddSuccess('The school program has been added successfully.');
            this.changes = !this.changes;
            this.resetAdd();
            this.trackFormChanges();
            this.modalService.dismissAll();
          } else {
            this.rpSer.showAddError('Failed to add the school program. Please try again.');
          }
        },
        (error: any) => {
          this.rpSer.showAddError();
        }
    );
  }
  getCurrentAcademicYear() {
    this.academicService.getAcademicYearsOnlyCurrent()
        .subscribe((response: AcademicYear) => {
          // @ts-ignore
          if (response['error'] === 0) {
            // @ts-ignore
            this.currentAcademic = new AcademicYear().deserialize(response['result']['data']);
          } else {
            // @ts-ignore
            // this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
          }
        }, (error: any) => {
          // this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        });
  }
  onAddCategory() {
    const data = this.addCategoryForm.value;
    this.schoolProgramService.createSchoolProgramCategory(data).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showAddSuccess('The school program category has been added successfully.');
            this.changes = !this.changes;
            this.resetCategory();
            this.trackFormChanges();
            this.modalService.dismissAll();
          } else {
            this.rpSer.showAddError(response.message);
          }
        },
        (error: any) => {
          this.rpSer.showAddError();
        }
    );
  }

}
